<template>
  <h1 v-bind:class="['ttl_h1', addClass]">{{ title }}</h1>
</template>

<script>
export default {
  name: 'h1-commom',
  props: ['title', 'addClass'],
}
</script>